export const POPSHOP_LOGO = 'https://i.loli.net/2020/07/01/Nvt3D1wf5aumGHz.png';
export const SHOPIFY_LOGO = 'https://i.loli.net/2020/07/01/uv3jkUlNaEdsQLI.png';
export const DEFAULT_IMAGE =
  'https://i.loli.net/2020/06/04/RrOTloXfUQ4Vi3j.png';
